import React from "react";
import IncomeItemGenericSkeleton from "./IncomeItemGenericSkeleton";

function IncomeItemDetailSkeleton() {
  return (
    <>
      <IncomeItemGenericSkeleton />
    </>
  );
}

export default IncomeItemDetailSkeleton;
